/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Archivedat1Inputs */

const en__field_archivedat1 = /** @type {(inputs: _Field_Archivedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived at`)
};

/**
* | output |
* | --- |
* | "Archived at" |
*
* @param {_Field_Archivedat1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_archivedat1 = /** @type {((inputs?: _Field_Archivedat1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Archivedat1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_archivedat1(inputs)
});
export { _field_archivedat1 as "_field_archivedAt" }